import { ensureSingleTagExists, ensureTagNotExists } from '../helpers';
import { ITagDefinition, TTag } from '../index';

const IBlackFridayTagType = 'advanced-black-friday';

export interface IBlackFridayTag {
  type: 'advanced-black-friday';
}

const isBlackFridayTag = (tag: TTag): tag is IBlackFridayTag => tag.type === IBlackFridayTagType;

export const blackFridayTagDefinition: ITagDefinition = {
  reduce: (tags, jsonQuery) => {
    const value = jsonQuery.is_black_friday && jsonQuery.is_black_friday.value;

    if (value !== undefined) {
      return ensureSingleTagExists(tags, isBlackFridayTag, () => ({ type: IBlackFridayTagType, value }));
    } else {
      return ensureTagNotExists(tags, isBlackFridayTag);
    }
  },
};
